'use client';
// React
import { HTMLAttributes, ReactElement } from 'react';
import styled from '@emotion/styled';
// Lib
import { IconProps } from './icon.interfaces';
import { ICONS, COLORS, SIZES } from './icon.constants';

const Icon = (props: IconProps): ReactElement | null => {
  const { name } = props;
  const Icon: React.FC<HTMLAttributes<HTMLElement>> = ICONS[name];

  if (!Icon) return null;

  const StyledIcon = styled(Icon)`
    fill: currentColor;
    color: ${({ color }: IconProps) => COLORS[color] || color || 'inherit'};
    width: ${({ size }: IconProps) => SIZES[size] || SIZES['medium']};
    height: ${({ size }: IconProps) => SIZES[size] || SIZES['medium']};
  `;

  return <StyledIcon {...props} />;
};

export default Icon;
